import { Component, OnInit, ViewChild, ElementRef, Input, OnDestroy } from '@angular/core';

import { TabOpenService } from '@services/tab-open.service';
import { DataSharingLTE } from '@fs/services/data-sharing-lte';
import { SettingTabs } from '@fs/enums/setting-tab';
import { ActionName } from '@shared/enums/action-name';
import { PermissionPipe } from '@shared/pipes/permission';
import { ISubscription } from "rxjs/Subscription";
import { AuthService } from '@services/auth.service';
import { CompanyComponent } from '../company/company.component';

@Component({
  selector: 'app-setting-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class SettingDashboardComponent implements OnInit,OnDestroy {

  //#region Input/Output/ViewChild
  @ViewChild("paymentTerms") paymentTerms: any;
  @ViewChild("promisedTime") promisedTime: any;
  @ViewChild("discount") discount: any;
  @ViewChild("accountingCodes") accountingCodes: any;
  @ViewChild("taxMaintenance") taxMaintenance: any
  @ViewChild("commonSetup") commonSetup: any
  @ViewChild("paymentMethods") paymentMethods: any;
  @ViewChild("companyInfo") companyInfo: CompanyComponent;
  @ViewChild("equipmentWarranty") equipmentWarranty:any;
  //#endregion

  //#region Variable Declarations
  private subscriptions: ISubscription[]=[];

  public tabCounter: number;
  public isUnsavedTriggered: boolean = false;
  public displayedTab: SettingTabs = SettingTabs.DashBoard;
  public settingTabs = SettingTabs;
  public actionName = ActionName;
  public routeToParent: boolean = false;
  public removeDirtyClass: boolean = false;
  public qbVersion: string = "";
  //#endregion

  //#region Constructor
  constructor(
    private tabopen: TabOpenService, 
    private elementRef: ElementRef, 
    private permissionPipe: PermissionPipe,
    public dataSharingLTE: DataSharingLTE,
    private auth:AuthService) {
    this.subscriptions.push(this.tabopen.routeToParentEvent.subscribe(response => {
      if (response.event == "destroy") {
        this.ResetUnsavedTrigger("");
        this.displayedTab = SettingTabs.DashBoard;
      }
      else if (response.event == "save") {
        if (this.displayedTab == SettingTabs.Company) {
          this.companyInfo.SaveInfo();
        }
        else {
          $(this.elementRef.nativeElement).find(".k-grid-edit-row").find(".customSave").click();
        }
        this.routeToParent = true;
      }
    }))
    this.subscriptions.push(this.dataSharingLTE.CloseSettingChildTabEvent.subscribe((response) => {
      this.OpenDashboard();
    }));
    this.qbVersion = (this.auth.getCompanyQBType()).toLowerCase();
  }
  //#endregion
  
  //#region Lifecycle Events
  ngOnInit() {
  }
  ngOnDestroy() {
    this.subscriptions.forEach(subscribed_elem => {
      subscribed_elem.unsubscribe();
      });
  }
  ngAfterViewChecked() {
    if (!this.isUnsavedTriggered) {
      let isDirty = ($(this.elementRef.nativeElement).children().first().hasClass('dirty'));
      if (isDirty) {
        this.isUnsavedTriggered = true;
        this.tabopen.unsavedChangedDetected({ dirty: isDirty, Index: this.tabCounter });
      }
    }
  }
  //#endregion

  //#region Methods
  public OpenPaymentTerms() {
    if (this.permissionPipe.transform(ActionName.PaymentTerms)) {
      this.isUnsavedTriggered = false;
      this.displayedTab = SettingTabs.PaymentTerm;
    }
  }

  /**
   * OpenCompanyInfo
   */
  public OpenCompanyInfo() {
     if (this.permissionPipe.transform(ActionName.Company)) {
      this.isUnsavedTriggered = false;
      this.displayedTab = SettingTabs.Company;
     }
  }

  public OpenPromisedTime() {
    if (this.permissionPipe.transform(ActionName.PromisedTime)) {
      this.isUnsavedTriggered = false;
      this.displayedTab = SettingTabs.PromisedTime;
    }
  }

  public OpenAccountingCode() {
    if (this.permissionPipe.transform(ActionName.AccountingCodes)) {
      this.isUnsavedTriggered = false;
      this.displayedTab = SettingTabs.AccountingCode;
    }
  }
  public OpenPaymentMethods() {
    if (this.permissionPipe.transform(ActionName.PaymentMethods)) {
      this.isUnsavedTriggered = false;
      this.displayedTab = SettingTabs.PaymentMethods;
    }
  }
  public OpenDiscount() {
    if (this.permissionPipe.transform(ActionName.Discount)) {
      this.isUnsavedTriggered = false;
      this.displayedTab = SettingTabs.Discount;
    }
  }

  public OpenTaxMaintenance() {
    if (this.permissionPipe.transform(ActionName.TaxMaintenance)) {
      this.isUnsavedTriggered = false;
      this.displayedTab = SettingTabs.TaxMaintenance;
    }
  }

  public OpenDashboard() {
    this.routeToParent = false;
    if ($(this.elementRef.nativeElement).children().first().hasClass('dirty'))
      this.tabopen.DestroyTab(this.tabCounter, "link");
    else
      this.displayedTab = SettingTabs.DashBoard;
  }

  public OpenCommonSetup() {
    if (this.permissionPipe.transform(ActionName.CompanyCodes)) {
      this.isUnsavedTriggered = false;
      this.displayedTab = SettingTabs.CommonSetup;
    }
  }
  /**
   * Open Equipment Warranty Setup
   */
  public OpenEquipmentWarranty() {
    if (this.permissionPipe.transform(ActionName.EquipmentWarranty)) {
      this.isUnsavedTriggered = false;
      this.displayedTab = SettingTabs.EquipmentWarranty;
    }
  }
  public ResetUnsavedTrigger(data: any) {
    this.tabopen.unsavedChangedDetected({ dirty: false, Index: this.tabCounter });
    this.isUnsavedTriggered = false;
  }
  //#endregion
}
